import { Box, Button, Typography } from '@mui/material';

function StatusFilterButton({
  label,
  count = 0,
  showCount = false,
  color = 'inherit',
  selected = false,
  onClick = () => undefined,
  size = 'small',
  minWidth = 0,
  withIcon = false,
  Icon,
  iconColor,
  sx = {},
}) {
  return (
    <Button
      variant={selected ? 'contained' : 'outlined'}
      color={color}
      onClick={onClick}
      size={size}
      sx={{
        borderRadius: 0.75,
        minHeight: 30,
        minWidth,
        px: 1,
        textTransform: 'none',
        ...sx,
      }}>
      <Box display="flex" alignItems="center">
        {withIcon && Icon && (
          <Icon
            color={iconColor || 'inherit'}
            fontSize="small"
            sx={{ mr: 1 }}
          />
        )}
        <Typography
          component="span"
          variant="body2"
          noWrap
          sx={{ color: 'inherit', fontWeight: 400 }}>
          {label}
        </Typography>
        {showCount && (
          <Typography
            component="span"
            variant="body2"
            sx={{ color: 'inherit', fontWeight: 'bold', ml: 1 }}>
            {count}
          </Typography>
        )}
      </Box>
    </Button>
  );
}

export default StatusFilterButton;
